import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "fileDetails",
})
export class FileDetailsPipe implements PipeTransform {
  transform(file: File, type: "NAME" | "SIZE" | "TYPE"): unknown {
    switch (type) {
      case "SIZE":
        return (file.size / (1024 * 1024)).toFixed(4)
          ? (file.size / (1024 * 1024)).toFixed(4) + "MB"
          : "N/A";

      case "NAME":
        return file.name;

      case "TYPE":
        const fileType = file.type.toString().split("/")[1];
        return fileType.toUpperCase();
      default:
        throw new Error("Invalid Type provided");
    }
  }
}
